import React from 'react'
import ReactMarkdown from 'markdown-to-jsx'

import options from 'src/constants/markdownToMuiConfig'

export default function Markdown({children}: {children: React.ReactNode}) {
  return <ReactMarkdown options={options}>{children as string}</ReactMarkdown>
}
